import { gql, TypedDocumentNode } from '@apollo/client'

import { Ability } from 'providers/casl/types/ability'
import { AD_UNIT_FRAGMENT } from '../fragments/adUnit'
import { AdUnitData, AdUnitVars } from '../types/adUnit'

type Props = {
  ability: Ability
  withControllingRefreshParamsOnAdUnitLevel?: boolean
}

export const GET_AD_UNIT = ({
  ability,
  withControllingRefreshParamsOnAdUnitLevel,
}: Props): TypedDocumentNode<AdUnitData, AdUnitVars> => {
  return gql`
    ${AD_UNIT_FRAGMENT({ ability, withControllingRefreshParamsOnAdUnitLevel })}

    query adUnit($id: ID!) {
      node(id: $id) {
        ...AdUnitFragment
      }
    }
  `
}
